import * as Yup from "yup";

const validateForm = (t: any) => {
  let schema = {};

  schema = Yup.object().shape({
    fullName: Yup.string()
      .required(t("interest.fullName.requiredError"))
      .min(4, t("interest.fullName.error")),
    companyName: Yup.string()
      .required(t("interest.businessInstName.requiredError"))
      .min(4, t("interest.businessInstName.error")),
    industry: Yup.string().required(t("interest.industry.requiredError")),
    companySize: Yup.string().required(t("interest.companySize.requiredError")),
    city: Yup.string().required(t("interest.city.requiredError")),
    phoneNumber: Yup.string().required(t("interest.phoneNumber.requiredError")),
    email: Yup.string()
      .email(t("interest.workEmail.error"))
      .required(t("interest.workEmail.requiredError")),
    message: Yup.string().required(t("interest.message.requiredError")).max(500, ""),
  });

  return schema;
};

export default validateForm;
